import React from 'react';
import {
  TextField,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CastingSlotsInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const CastingSlotsInput: React.FC<CastingSlotsInputProps> = ({
  value,
  onChange,
  error
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        multiline
        rows={4}
        label={t('proposal.casting.slotsLabel')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        helperText={error || t('proposal.casting.slotsHelperText')}
        required
        placeholder={t('proposal.casting.slotsPlaceholder')}
      />
    </Box>
  );
};

export default CastingSlotsInput;
